module.exports = __webpack_public_path__ + "images/category_lp/furniture/assessment_achievements/5@2x_df3c5be2eeff317cfcedc37c0a5064dd.png";